import { render, staticRenderFns } from "./ArticleDeleteDialog.vue?vue&type=template&id=5f2ee546&"
import script from "./ArticleDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ArticleDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports